import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { SubItem } from "src/app/core/services/business/model/sub-item";
import { DemanderSignature } from "src/app/core/services/business/model/demande-signature/demander-signature";
import { SubItemService } from "src/app/core/services/business/service/sub-item.service";
import { DemandeSignatureService } from "src/app/core/services/business/service/demande-signature.service";

@Component({
  selector: "app-demander-signature-modal",
  templateUrl: "./demander-signature-modal.component.html",
  styleUrls: ["./demander-signature-modal.component.scss"],
})
export class DemanderSignatureModalComponent implements OnInit {
  @Input() subitemId;
  @Input() refDossierPortail;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  subitem: SubItem;

  demanderSignature: DemanderSignature = new DemanderSignature();

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _subItemService: SubItemService,
    private _demandeSignature: DemandeSignatureService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      commentaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.spinner.show();

    this.demanderSignature.idFichierASigner = this.subitemId;
    this.demanderSignature.refDossierPortail = this.refDossierPortail;
    this.demanderSignature.commentaire = this.form2.value.commentaire;

    this._demandeSignature
      .add(this.demanderSignature)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
